import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

export function TeamsAdminApproval() {
    return (
        <OnboardingBody title='Permission must be granted by your Microsoft admin'>
            <div className='mt-16'>
                <BulletedList
                    bullets={[
                        'Nutshell’s Teams integration requires admin-granted Microsoft permissions to view your transcriptions and recordings',
                        <Body key='1'>
                            Instructions to grant these permissions to Nutshell in Azure can be
                            found{' '}
                            <Link
                                href='https://support.nutshell.com/en/articles/12352779-integrations-connecting-microsoft-teams-to-nutshell'
                                newTab={true}
                            >
                                here
                            </Link>
                        </Body>,
                    ]}
                />
            </div>
        </OnboardingBody>
    );
}
